// Reusable debounce utility — add once at the top of custom.js:
function debounce(fn, delay = 150) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

/* Tab Start */
function InitTabs() {
  document.querySelectorAll(".Tabs_common_main_new").forEach((container) => {
    const tabs = container.querySelectorAll(".Tabs_common_inner_new");
    const contents = container.querySelectorAll(".tabcontent");

    const group = container.querySelector("[data-tab-group]");
    const bg = group ? group.querySelector(".tab_background_new") : null;

    function moveBgToTab(tab) {
      if (!group || !bg) return;

      const tabsArr = Array.from(tabs);
      const isLast = tab === tabsArr[tabsArr.length - 1];

      const tabRect = tab.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();

      let offset = tabRect.left - groupRect.left;

      // 3px gap on last tab
      if (isLast) offset -= 0;

      bg.style.width = `${tabRect.width}px`;
      bg.style.transform = `translateX(${offset}px)`;
    }

    function activateTab(tab) {
      const tabId = tab.getAttribute("tab_id");
      if (!tabId) return;

      tabs.forEach((t) => t.classList.remove("active"));
      contents.forEach((c) => (c.style.display = "none"));
      contents.forEach((c) => c.classList.remove("active"));

      tab.classList.add("active");

      const targets = container.querySelectorAll(`.${tabId}_open`);
      targets.forEach((t) => (t.style.display = "block"));
      targets.forEach((t) => t.classList.add("active"));

      moveBgToTab(tab);
    }

    // 🔥 Recalculate background position on screen resize
    function updateActiveTabBg() {
      const activeTab = container.querySelector(
        ".Tabs_common_inner_new.active",
      );
      if (activeTab) moveBgToTab(activeTab);
    }
    window.addEventListener("resize", debounce(updateActiveTabBg, 150));

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activateTab(tab));
    });

    const firstActive =
      container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
    if (firstActive) activateTab(firstActive);

    const navMenu = document.querySelector(".menu-list__list-item");

    if (navMenu) {
      navMenu.addEventListener("mouseenter", () => {
        const firstActive =
          container.querySelector(".Tabs_common_inner_new.active") || tabs[0];
        if (firstActive) activateTab(firstActive);
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  InitTabs();
});
document.addEventListener("shopify:section:load", () => {
  InitTabs();
});
/* Tab End */

/* Accordian Start */
function initCustomAccordion(root) {
  const scope = root || document;
  scope.querySelectorAll(".accordion").forEach((acc) => {
    const items = acc.querySelectorAll("li");

    items.forEach((item) => {
      if (item.dataset.accordionBound === "true") return;
      item.dataset.accordionBound = "true";

      const question = item.querySelector(".question");
      const answer = item.querySelector(".answer");

      if (!question || !answer) return;

      // Ensure correct default state
      if (item.classList.contains("open")) {
        answer.style.display = "block";
        answer.style.height = "auto";
      } else {
        answer.style.display = "none";
        answer.style.height = 0;
      }

      question.addEventListener("click", () => {
        const isOpen = item.classList.contains("open");

        // Close all other items
        items.forEach((i) => {
          if (i === item) return;
          i.classList.remove("open");
          const a = i.querySelector(".answer");
          if (a) {
            a.style.height = a.scrollHeight + "px"; // ensure correct closing start
            requestAnimationFrame(() => {
              a.style.transition = "height 300ms ease";
              a.style.height = "0px";
            });
            setTimeout(() => {
              a.style.display = "none";
              a.style.removeProperty("transition");
            }, 300);
          }
        });

        // If the clicked one was open, just close it
        if (isOpen) {
          item.classList.remove("open");
          answer.style.height = answer.scrollHeight + "px";
          requestAnimationFrame(() => {
            answer.style.transition = "height 300ms ease";
            answer.style.height = "0px";
          });
          setTimeout(() => {
            answer.style.display = "none";
            answer.style.removeProperty("transition");
          }, 300);
          return;
        }

        // Otherwise, open it
        item.classList.add("open");
        answer.style.display = "block";
        answer.style.height = "auto"; // get natural height
        const endHeight = answer.scrollHeight + "px";
        answer.style.height = "0px"; // restart animation
        requestAnimationFrame(() => {
          answer.style.transition = "height 300ms ease";
          answer.style.height = endHeight;
        });
        // Wait until animation finishes, then scroll
        setTimeout(() => {
          answer.style.height = "auto";
          answer.style.removeProperty("transition");

          // ✅ Scroll ONLY if inside Product_meta_collapsible_main_new
          const container = item.closest(".Product_meta_collapsible_main_new");
          if (container) {
            // Scroll to question AFTER opening
            const offset = 100; // adjust to your header height
            const y =
              question.getBoundingClientRect().top +
              window.pageYOffset -
              offset;

            window.scrollTo({
              top: y,
              behavior: "smooth",
            });
          }
        }, 300);
      });
    });
  });
}

window.initCustomAccordion = initCustomAccordion;
initCustomAccordion(document);
/* Accordian End */

/* Mobile Header Start */
function mobileMenuHeight() {
  // Get announcement bar height (with margin)
  const announcementBar = document.querySelector(".Announcement_main_new");
  const announcementBarHeight = announcementBar
    ? announcementBar.offsetHeight
    : 0;

  // Fixed header height
  const headerEl = document.querySelector(".header__row");
  const headerHeight = headerEl ? headerEl.offsetHeight : 53; // 56 as fallback
  const totalHeight = announcementBarHeight + headerHeight;

  // Update drawer positions
  const menuDrawer = document.querySelector(".menu-drawer");
  const menuBackdrop = document.querySelector(".menu-drawer__backdrop");

  if (menuDrawer) {
    menuDrawer.style.top = totalHeight + "px";
    menuDrawer.style.height = `calc(100dvh - ${totalHeight}px)`;
  }
  if (menuBackdrop) {
    menuBackdrop.style.top = totalHeight + "px";
  }

  // For elements with [data-scroll-direction="up"]
  const upElements = document.querySelectorAll(
    "[data-scroll-direction='up'], [data-scroll-direction='down']",
  );
  const totalHeightUp = headerHeight - 1;

  upElements.forEach((el) => {
    const upMenu = el.querySelector(".menu-drawer");
    const upBackdrop = el.querySelector(".menu-drawer__backdrop");

    if (upMenu) {
      upMenu.style.top = totalHeightUp + "px";
      upMenu.style.height = `calc(100dvh - ${totalHeightUp}px)`;
    }
    if (upBackdrop) {
      upBackdrop.style.top = totalHeightUp + "px";
    }
  });
}

// Initial run
mobileMenuHeight();

// Recalculate on menu button click
const menuBtn = document.querySelector(".header__icon--menu");
if (menuBtn) {
  menuBtn.addEventListener("click", mobileMenuHeight);
}

// Recalculate on window resize
window.addEventListener("resize", debounce(mobileMenuHeight, 150));
/* Mobile Header End */

/* Video Lazy Load */
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".lazy-video");
  const isMobile = () => window.innerWidth <= 750;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        const shouldLoad =
          (video.classList.contains("Mobile_video_new") && isMobile()) ||
          (video.classList.contains("Desktop_video_new") && !isMobile());

        if (!shouldLoad) return;

        // 🔹 PRELOAD when close (even if not visible yet)
        if (entry.intersectionRatio > 0 && !video.dataset.loaded) {
          video.src = video.dataset.src;
          video.preload = "auto";
          video.load();
          video.dataset.loaded = "true";
        }

        // 🔹 PLAY only when visible
        // if (entry.isIntersecting) {
        //   if (video.readyState >= 2) {
        //     video.play().catch(() => {});
        //   } else {
        //     video.addEventListener(
        //       "loadeddata",
        //       () => video.play().catch(() => {}),
        //       { once: true }
        //     );
        //   }
        // } else {
        //   // Optional pause
        //   // video.pause();
        // }
        const hasToggle = video
          .closest(".Collection_innermedia_new")
          ?.querySelector(".Collection_video_toggle_new");

        if (entry.isIntersecting && !hasToggle) {
          if (video.readyState >= 2) {
            video.play().catch(() => {});
          } else {
            video.addEventListener(
              "loadeddata",
              () => video.play().catch(() => {}),
              { once: true },
            );
          }
        }
      });
    },
    {
      threshold: [0, 0.25],
      rootMargin: "400px 0px", // VERY IMPORTANT
    },
  );

  videos.forEach((video) => observer.observe(video));
});
/* Video Lazy Load */

/* Footer Email */
document.addEventListener("DOMContentLoaded", function () {
  // Replace this with your actual Klaviyo form ID
  const formSelector = ".Footer_block_inneremail_innerforms_new";

  // Watch for Klaviyo form to be added to DOM
  if (formSelector) {
    const observer = new MutationObserver(() => {
      const form = document.querySelector(formSelector);
      if (form) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.addEventListener("input", function () {
            this.classList.toggle("typing", this.value.trim() !== "");
          });
          observer.disconnect(); // Stop watching once done
        }
      }
    });

    // Start observing the body for form injection
    observer.observe(document.body, { childList: true, subtree: true });

    // Kill observer after 15 seconds if form never appears
    const watchdogTimer = setTimeout(() => observer.disconnect(), 15000);

    // Also add inside the disconnect() call:
    observer.disconnect();
    clearTimeout(watchdogTimer);
  }
});
/* Footer Email */

/* Footer Section Image */
let activated = false;

window.addEventListener("scroll", function () {
  if (activated) return;

  const element = document.querySelector(
    ".Footer_block_innerpart_inneritem_mainicon_new",
  );
  if (!element) return;

  const isBottom =
    window.innerHeight + window.scrollY >=
    document.documentElement.scrollHeight - 5;

  if (isBottom) {
    element.classList.add("active");
    activated = true;
  }
});
/* Footer Section Image */

/* Scrollbar */
document.querySelectorAll(".simplebar").forEach((el) => {
  new SimpleBar(el, {
    autoHide: false,
  });

  // SimpleBar adds tabindex="0" + aria-label to its generic wrapper div;
  // aria-label is not allowed on a generic div, so drop both.
  el.querySelectorAll(".simplebar-content-wrapper").forEach((wrapper) => {
    wrapper.removeAttribute("tabindex");
    wrapper.removeAttribute("aria-label");
  });
});
/* Scrollbar */

/* Product Page */
function productPageScript() {
  document.addEventListener("DOMContentLoaded", function () {
    const target = document.querySelector(".product-form-buttons");
    if (!target) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const rect = entry.boundingClientRect;

          if (entry.isIntersecting) {
            // Near / visible → remove class
            document.body.classList.remove("fixed_atc");
          } else {
            if (rect.top > 0) {
              // Element is BELOW viewport (user is above it)
              document.body.classList.add("fixed_atc");
            } else {
              // Element is ABOVE viewport (user scrolled past it)
              // Do NOTHING → keep class removed
            }
          }
        });
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px 10px 0px",
      },
    );

    observer.observe(target);
  });

  initMarquee(".Product_benefits_marquees_marquee", {
    mobile: {
      duration: 50000,
      gap: 0,
      duplicated: true,
      direction: "left",
    },
    desktop: {
      duration: 80000,
      gap: 0,
      duplicated: true,
      direction: "left",
    },
  });

  // ✅ Marquee Play/Pause button logic
  document.querySelectorAll(".a11y-marquee-toggle").forEach(function (btn) {
    var marquee = btn.previousElementSibling; // .Product_benefits_marquees_marquee
    if (!marquee) return;

    var wrapper = marquee.querySelector(".js-marquee-wrapper");
    if (!wrapper) return;

    var isPlaying = true;

    btn.addEventListener("click", function () {
      isPlaying = !isPlaying;
      var state = isPlaying ? "running" : "paused";

      wrapper.style.animationPlayState = state;
      wrapper.querySelectorAll("*").forEach(function (el) {
        el.style.animationPlayState = isPlaying ? "" : "paused";
      });

      btn.textContent = isPlaying ? "Icon Pause" : "Icon Play";
      btn.setAttribute(
        "aria-label",
        isPlaying ? "Pause moving logos" : "Play moving logos",
      );
      btn.setAttribute("data-marquee-playing", isPlaying ? "true" : "false");
    });
  });

  /* Retailer Drawer */
  // The trigger is a <div> (product-meta-retailer-new block), so give it
  // button semantics and keyboard support here.
  let retailerDrawerTrigger = null;

  function enhanceRetailerTriggers() {
    document
      .querySelectorAll(".PDP_retailer_drawer_open:not([role])")
      .forEach((trigger) => {
        if (trigger.matches("button, a[href]")) return;
        trigger.setAttribute("role", "button");
        trigger.setAttribute("tabindex", "0");
        trigger.setAttribute("aria-haspopup", "dialog");
        trigger.setAttribute("aria-expanded", "false");
      });
  }
  enhanceRetailerTriggers();
  // Re-apply when the product section is re-rendered (e.g. variant change)
  new MutationObserver(debounce(enhanceRetailerTriggers, 200)).observe(
    document.body,
    { childList: true, subtree: true },
  );

  document.addEventListener("keydown", function (e) {
    const trigger = e.target.closest('.PDP_retailer_drawer_open[role="button"]');
    if (!trigger || (e.key !== "Enter" && e.key !== " ")) return;
    e.preventDefault();
    trigger.click();
  });

  function closeRetailerDrawer() {
    const openPopups = document.querySelectorAll(".PDP_retailer_popup_new.open");
    if (!openPopups.length) return;

    document.body.classList.remove("PDP_retailer_drawer_is_open");
    openPopups.forEach((el) => {
      el.classList.remove("open");
      el.inert = true;
    });

    if (retailerDrawerTrigger) {
      retailerDrawerTrigger.setAttribute("aria-expanded", "false");
      retailerDrawerTrigger.focus();
      retailerDrawerTrigger = null;
    }
  }

  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".PDP_retailer_drawer_open");
    if (!trigger) return;

    const popupClass = trigger.getAttribute("popup_id");
    if (!popupClass) return;

    // close any open popup first
    document.querySelectorAll(".PDP_retailer_popup_new.open").forEach((el) => {
      el.classList.remove("open");
      el.inert = true;
    });

    const target = document.querySelector(
      `.PDP_retailer_popup_new.${popupClass}`,
    );
    if (!target) return;

    target.inert = false;
    target.classList.add("open");
    document.body.classList.add("PDP_retailer_drawer_is_open");

    retailerDrawerTrigger = trigger;
    trigger.setAttribute("aria-expanded", "true");
    (target.querySelector(".PDP_retailer_drawer_close") || target).focus();
  });

  document.addEventListener("click", function (e) {
    const closeTrigger = e.target.closest(
      ".PDP_retailer_drawer_overlay_new, .PDP_retailer_drawer_close",
    );
    if (!closeTrigger) return;
    closeRetailerDrawer();
  });

  // Escape closes; Tab stays inside the open drawer
  document.addEventListener("keydown", function (e) {
    const popup = document.querySelector(".PDP_retailer_popup_new.open");
    if (!popup) return;

    if (e.key === "Escape") {
      closeRetailerDrawer();
      return;
    }

    if (e.key !== "Tab") return;
    const focusable = Array.from(
      popup.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
    ).filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === popup)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
  /* Retailer Drawer */

  /* Nutrition Drawer */
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".PDP_nutrition_drawer_open");
    if (!trigger) return;

    const popupClass = trigger.getAttribute("popup_id");
    if (!popupClass) return;

    // close any open popup first
    document
      .querySelectorAll(".PDP_nutrition_popup_new.open")
      .forEach((el) => el.classList.remove("open"));

    const target = document.querySelector(
      `.PDP_nutrition_popup_new.${popupClass}`,
    );
    if (!target) return;

    target.classList.add("open");
    document.body.classList.add("PDP_nutrition_drawer_is_open");
  });

  document.addEventListener("click", function (e) {
    const closeTrigger = e.target.closest(
      ".PDP_nutrition_drawer_overlay_new, .PDP_nutrition_drawer_close",
    );
    if (!closeTrigger) return;

    document.body.classList.remove("PDP_nutrition_drawer_is_open");

    document
      .querySelectorAll(".PDP_nutrition_popup_new.open")
      .forEach((el) => el.classList.remove("open"));
  });
  /* Nutrition Drawer */

  /* Quantity */
  document.addEventListener("DOMContentLoaded", function () {
    const radios = document.querySelectorAll('input[name="quantity_selector"]');
    const realInput = document.querySelector("#real-quantity-input");
    if (realInput) realInput.setAttribute("aria-label", "Quantity");

    function updateBoxData(selected) {
      const boxCount = selected.getAttribute("each_box");
      const boxSize = selected.getAttribute("number_of_boxes");

      document.querySelectorAll(".PDP_box_count").forEach((el) => {
        el.textContent = boxCount;
      });

      document.querySelectorAll(".PDP_box_size").forEach((el) => {
        el.textContent = boxSize;
      });
    }

    // Set initial value on page load
    const checkedRadio = document.querySelector(
      'input[name="quantity_selector"]:checked',
    );
    if (checkedRadio) {
      realInput.value = checkedRadio.value;
      updateBoxData(checkedRadio);
    }

    // Handle change
    radios.forEach((radio) => {
      radio.addEventListener("change", function () {
        realInput.value = this.value;
        updateBoxData(this);
      });
    });
  });
  /* Quantity */

  /* Dropdown Flavor */
  document.addEventListener("DOMContentLoaded", function () {
    const dropdown = document.querySelector(
      ".PDP_stitcher_flavor_dropdown_new",
    );
    const parent = document.querySelector(".PDP_stitcher_flavor_loop_new");

    // Toggle on touch
    dropdown.addEventListener("touchstart", function (e) {
      e.stopPropagation();
      parent.classList.toggle("open");
    });

    // Prevent closing when touching inside parent
    parent.addEventListener("touchstart", function (e) {
      e.stopPropagation();
    });

    // Close when touching outside
    document.addEventListener("touchstart", function () {
      parent.classList.remove("open");
    });
  });
  /* Dropdown Flavor */

  /* Sticky Wave */
  const body = document.body;

  const sections = document.querySelectorAll("#MainContent .shopify-section");
  const targetSection = sections[1];
  const pdpSection = document.querySelector("#MainContent .PDP_template_new");

  function handleScroll() {
    const scrollY = window.scrollY;

    // wave_fixed
    body.classList.toggle("wave_fixed", scrollY > 0);

    // wave_reached
    if (targetSection) {
      const rect = targetSection.getBoundingClientRect();
      body.classList.toggle("wave_reached", rect.top <= window.innerHeight);
    }

    // cta-visible
    if (pdpSection) {
      const rect = pdpSection.getBoundingClientRect();
      body.classList.toggle("cta-visible", rect.bottom < 0);
    }
  }

  window.addEventListener("scroll", handleScroll);
  /* Sticky Wave */
}

if (document.body.classList.contains("template-product")) {
  productPageScript();
}
/* Product Page */

/*
document.querySelectorAll('.Index_object_testimonial_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: false,
        spaceBetween: 24,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        centeredSlides: true,
        observer: true,
        observeParents: true,
        freeMode: !0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        breakpoints: {
            0: {
                freeMode: !1,
                centeredSlides: false,
                spaceBetween: 16
            },
            750: {
                centeredSlides: true,
                spaceBetween: 24
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});
*/

if (window.innerWidth < 990) {
  initMarquee(".sliding-images_grid", {
    mobile: {
      duration: 40000,
      gap: 20,
      duplicated: true,
      direction: "left",
    },
  });
}
